import React, { PureComponent } from 'react';
import styled from '@emotion/styled'
import OnVisible from 'react-on-visible';
import FeaturedCase01Component from './featuredCase01.component';
import FeaturedCase02Component from './featuredCase02.component';
import FeaturedCase03Component from './featuredCase03.component';
import FeaturedCase04Component from './featuredCase04.component';
import FeaturedCase05Component from './featuredCase05.component';
import FeaturedCase06Component from './featuredCase06.component';

class FeaturedCaseComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.navigateToCase = this.navigateToCase.bind(this);
  }

  navigateToCase(event, slug) {
    event.preventDefault();

    /*MethodsService.getMethod('navigateWithTransition')(
        'toCase',
        <TeaserImage>
            <Image {...image} />
        </TeaserImage>,
        this.box.getBoundingClientRect(),
        `/work/${slug}/`
    );*/
  }
  renderCaseLayout() {
    const { layout } = this.props;
    let caseData = this.props.case;

    if (layout == 1) {
      return <FeaturedCase01Component {...this.props.case} slug={`work/${this.props.case.slug}`} />;
    }
    if (layout == 2) {
      return <FeaturedCase02Component {...this.props.case} slug={`work/${this.props.case.slug}`} />;
    }
    if (layout == 3) {
      return <FeaturedCase03Component {...this.props.case} slug={`work/${this.props.case.slug}`} />;
    }
    if (layout == 4) {
      return <FeaturedCase04Component {...this.props.case} slug={`work/${this.props.case.slug}`} />;
    }
    if (layout == 5) {
      return <FeaturedCase05Component {...this.props.case} slug={`work/${this.props.case.slug}`} />;
    }
    if (layout == 6) {
      return <FeaturedCase06Component {...this.props.case} slug={`work/${this.props.case.slug}`} />;
    }
  }
  render() {
    // 1,2,1,3,1,2,4,1,5,6
    return (
      <div className="wrapper">
        <div className="container-fluid">
      <FeatureCaseWrapper percent={30}>
        {/* <Link
                        to={`/work/${slug}/`}
                        onClick={event => this.navigateToCase(event, slug)}> */}
        {this.renderCaseLayout()}
        {/* </Link> */}
      </FeatureCaseWrapper>
      </div>
      </div>
    );
  }
}

const FeatureCaseWrapper = styled(OnVisible)`
  background-color: #fff;
`;

export default FeaturedCaseComponent;
